import { performRequestSecond } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';
import moment from 'moment';

export const updateWorkFlowAutomationRules = (action_item_update = false, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateAutomationRules}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&action_item_update=${action_item_update}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};
export const getWorkFlowAutomationRuleDetails = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const pkModified = pk?.replaceAll('#', '%23');
  const skModified = sk?.replaceAll('#', '%23');
  let url = `${apiEndPoints.getAutomationRuleDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkModified}&sk=${skModified}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getWorkFlowAutomationStoppedInstances = (automationId, pageLimit, pagination_token, pagination_direction, filter) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listStoppedAutomationInstances}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&automation_pk=${tenantId}#${automationId}`;
  if (pageLimit) {
    url += `&pageLimit=${pageLimit}`;
  }
  if (pagination_token) {
    url += `&pagination_token=${pagination_token}`;
  }
  if (pagination_direction) {
    url += `&pagination_direction=${pagination_direction}`;
  }
  if (filter?.case_lead?.id) {
    url += `&case_id=${filter?.case_lead?.id}`;
  }
  if (filter?.instance_stop_time) {
    url += `&instance_stop_time=${moment(filter?.instance_stop_time).utc().format('YYYY-MM-DDTHH:mm:ss.SSSSSS[+00:00]')}`;
  }
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getWorkFlowAutomationStoppedInstancesActions = (automationId, instance_id) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.listStoppedAutomationInstancesActions}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&automation_pk=${tenantId}#${automationId}&instance_id=${instance_id}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};

export const getWorkFlowAutomationRestartInstance = (qsParams) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.restartAutomationInstance}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&${qsParams}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};
